// Prev / close / next navigation for the calendar sidebar "phone" preview exercise
// detail. Modeled on the workouts module's ButtonInnerElement, copied locally.
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { BoxShadow } from '../../../../shared/GlobalStyles';

const NavWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 4px;
`;

const ButtonInner = styled('div')`
  display: flex;
  width: 100%;
  max-width: 250px;
  background: white;
  border-radius: 50px;
  border: 1px solid #f0f0f0;
  justify-content: space-between;
  box-shadow: ${BoxShadow};
`;

const NavButton = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  height: 50px;
  width: 50px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  :hover {
    opacity: ${(props) => (props.disabled ? 1 : 0.7)};
  }
`;

const CalendarExerciseNav = ({
  activeIndex, total, onPrev, onNext, onClose,
}) => {
  const isFirst = activeIndex <= 0;
  const isLast = activeIndex >= total - 1;

  return (
    <NavWrapper>
      <ButtonInner>
        <NavButton type='button' disabled={isFirst} onClick={() => !isFirst && onPrev()}>
          <IcomoonReact
            iconSet={iconSet}
            size={25}
            icon='left-arrow'
            color={isFirst ? 'lightgrey' : 'black'}
          />
        </NavButton>
        <NavButton type='button' onClick={onClose}>
          <IcomoonReact iconSet={iconSet} size={22} icon='remove' color='black' />
        </NavButton>
        <NavButton type='button' disabled={isLast} onClick={() => !isLast && onNext()}>
          <IcomoonReact
            iconSet={iconSet}
            size={25}
            icon='right-arrow'
            color={isLast ? 'lightgrey' : 'black'}
          />
        </NavButton>
      </ButtonInner>
    </NavWrapper>
  );
};

CalendarExerciseNav.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CalendarExerciseNav;
